module.exports = __webpack_public_path__ + "media/images/landing_page/mountains-28e26ef1d3e783fc1a53078bb7988b5b.jpg";